export default "__VITE_ASSET__D$XkFDMN__"